/* CreateAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateQuestionComponent = require("./CreateQuestionComponent");

class CreateAction {
    constructor(logger, gameEditor, modalUserFeedback, TriggerTypeEntity, userSession) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._triggerTypeEntity = new TriggerTypeEntity(userSession.activeOrganization.id);
        this._modalUserFeedback = modalUserFeedback;
        this.run = this.run.bind(this);
    }
    run() {
        return this._modalUserFeedback
            .displayCustom(new CreateQuestionComponent(this._logger), { dontHide: true })
            .then((result) => {
                this._modalUserFeedback.displayLoading();
                return this._createTriggerType(result.trim()).catch((err) => {
                    this._logger.warn({ error: err }, "CreateAction._createTriggerType() error.");
                    return this._modalUserFeedback.displayError(err);
                });
            })
            .then((result) => {
                let editorState = {
                    fqn: Registrations.WTE_VIEW_DETAILS,
                    viewState: { createMode: true }
                };
                let launchOpts = {
                    id: result.id,
                    title: result.properties.name
                };
                this._gameEditor.launchWorkTriggerEditor(editorState, launchOpts);
                return this._modalUserFeedback.hideDisplayed();
            })
            .catch((err) => {
                this._logger.warn({ error: err }, "CreateAction.run() - Either error or cancellation");
                return this._modalUserFeedback.hideDisplayed();
            });
    }

    _createTriggerType(name) {
        // Defaults
        this._triggerTypeEntity.name = name;
        this._triggerTypeEntity.description = "";
        return this._triggerTypeEntity.create();
    }
}
module.exports = CreateAction;

CreateAction.$inject = ["$teve.logger", "gameEditor.gameEditor", "$teve.ui.userFeedback", "$teve.entities.TriggerType", "$teve.userSession"];

CreateAction.$displayDetails = {
    type: "Action",
    name: "CreateAction",
    icon: "configdrift.add_device",
    shown: true,
    title: "Add Schedule",
    order: 3
};
